import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { DEFAULT_THEME, appearanceUserKey } from '../utils/appearanceDefaults';

const Context = createContext({ active: false, theme: DEFAULT_THEME, setTheme: () => {} });
export const useMaquetesTheme = () => useContext(Context);
export function MaquetesThemeProvider({ children }) {
    const { user } = useAuth();
    const { pathname } = useLocation();
    const key = `maquetes_visual_theme_${appearanceUserKey(user)}`;
    const [selection, setSelection] = useState(() => {
        try { return { key, user, value: localStorage.getItem(key) || DEFAULT_THEME }; }
        catch { return { key, user, value: DEFAULT_THEME }; }
    });
    const storedTheme = () => { try { return localStorage.getItem(key) || DEFAULT_THEME; } catch { return DEFAULT_THEME; } };
    const selected = selection.key === key && selection.user === user ? selection.value : storedTheme();
    const theme = selected === 'claro' ? 'liquido' : ['original', 'liquido'].includes(selected) ? selected : DEFAULT_THEME;
    useEffect(() => { if (selected === 'claro') { setSelection({key,user,value:DEFAULT_THEME}); try { localStorage.setItem(key,'liquido'); } catch (_) {} } }, [selected,key,user]);
    const active = (/^\/(?:maquetes|relatorios)(?:\/|$)/.test(pathname) && theme === 'liquido')
        || ((pathname === '/' || /^\/(?:orcamentos|planeamento|manutencoes|utilizadores|admin-fichas|configuracoes|lixeira|notificacoes|gestao-financeira|obras|trabalhadores|recursos-humanos|equipamentos|veiculos|despesas|revolut|reconciliacao|sistema-integrado)(?:\/|$)/.test(pathname)) && theme === 'liquido');
    const setTheme = value => {
        if (!['original', 'liquido'].includes(value)) return;
        setSelection({ key, user, value });
        try { localStorage.setItem(key, value); } catch { /* Keep the current session usable. */ }
    };
    return <Context.Provider value={{ active, theme, setTheme }}>{children}</Context.Provider>;
}
